export const REASON_POSTING_DISABLED = "member_posting_disabled";
export const REASON_COMPOSER_NOT_OFFERED = "composer_not_offered";
export const REASON_NOT_ELIGIBLE = "not_eligible_to_post";
export const REASON_MEMBER_BLOCKED = "member_blocked";
export const REASON_MEDIA_NOT_ALLOWED = "media_not_allowed";
export const REASON_TOO_LONG = "post_too_long";
export const REASON_RATE_LIMITED = "rate_limited";

const MESSAGE_BY_REASON = {
  [REASON_POSTING_DISABLED]: "Posting is turned off on this site right now.",
  [REASON_COMPOSER_NOT_OFFERED]: "This kind of post is not accepted here.",
  [REASON_NOT_ELIGIBLE]: "You do not have access to post here yet.",
  [REASON_MEMBER_BLOCKED]: "You cannot post here.",
  [REASON_MEDIA_NOT_ALLOWED]: "Images are not allowed here. Remove the image to post.",
  [REASON_TOO_LONG]: "That is too long to post here. Shorten it and try again.",
  [REASON_RATE_LIMITED]: "You have posted a lot recently. Try again in a little while.",
};

const RETRYABLE_REASONS = [
  REASON_MEDIA_NOT_ALLOWED,
  REASON_TOO_LONG,
  REASON_RATE_LIMITED,
];

const IMAGE_ONLY_REASONS = [REASON_MEDIA_NOT_ALLOWED];

const FALLBACK_MESSAGE = "That did not post. Your words are still here — try again.";

export function refusalReasonFromError(error) {
  const reason = error?.response?.data?.error;

  return typeof reason === "string" && reason !== "" ? reason : "";
}

export function refusalMessageFor(reason) {
  return MESSAGE_BY_REASON[reason] ?? FALLBACK_MESSAGE;
}

export function describeRefusal(error) {
  const reason = refusalReasonFromError(error);

  return {
    reason,
    message: refusalMessageFor(reason),
    keepsText: true,
    clearsImageOnly: IMAGE_ONLY_REASONS.includes(reason),
    retryable: RETRYABLE_REASONS.includes(reason),
  };
}
